'use client'

import { RadioGroup as RadioGroupPrimitive } from 'radix-ui'
import * as React from 'react'

import { cn } from '@/legacy-src/lib/utils'

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return <RadioGroupPrimitive.Root className={cn('grid gap-2', className)} {...props} ref={ref} />
})
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        'group peer relative aspect-square h-6 w-6 rounded-full border-2 border-solid border-petrol-500 bg-transparent text-petrol-500 outline-none hover:border-petrol-300 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:border-sand-700',
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className="absolute bottom-0 left-0 right-0 top-0 h-full w-full shrink-0 rounded-full bg-petrol-500 group-hover:bg-petrol-300 group-disabled:bg-sand-700">
        <span className="absolute bottom-0 left-0 right-0 top-0 z-10 m-auto h-3 w-3 rounded-full bg-white group-disabled:bg-sand-600" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  )
})
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName

const RadioGroupCard = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, children, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        'h-[52px] border-spacing-2 rounded-xl border-solid border-petrol-500 bg-white p-3 text-xs font-bold text-petrol-500 disabled:cursor-not-allowed disabled:border-sand-400 disabled:bg-sand-400 disabled:text-sand-700 data-[state=checked]:bg-secondary data-[state=checked]:text-white data-[state=checked]:outline-none disabled:data-[state=checked]:border-petrol-500',
        className,
      )}
      {...props}
    >
      {children}
    </RadioGroupPrimitive.Item>
  )
})

RadioGroupCard.displayName = 'RadioGroupCard'

export { RadioGroup, RadioGroupItem, RadioGroupCard }
